export default __webpack_public_path__ + "static/img-point-first-7cd472bb51cf79c336fd7f5631968c27.avif";